import React, {useEffect} from "react";

const LevelItem = ({title, details}) => {
    return (
        <div className={'plan-item flexColumn'} data-testid={'levelItemDiv'}>
            <div className={'plan-sub-title'}>
                {title}
            </div>
            <div className={'plan-sub-details'}>
                {details}
            </div>
        </div>
    );
}

export default LevelItem;